const navigation = () => {

    const CLASSES = {
        'slider': 'roadmap-timeline__container',
        'buttonLeft': 'roadmap-timeline__controls__control--left',
        'buttonRight': 'roadmap-timeline__controls__control--right',
        'active': 'active'
    }

    const slider = document?.querySelector('.' + CLASSES.slider);
    const buttonLeft = document?.querySelector('.' + CLASSES.buttonLeft);
    const buttonRight = document?.querySelector('.' + CLASSES.buttonRight);

    const contentScrollWidth = slider?.scrollWidth;
    let contentScollLeft = slider?.scrollLeft;

    if (buttonRight != null && buttonLeft != null) {
        buttonLeft.parentElement.setAttribute("role", "button");
        buttonLeft.parentElement.setAttribute("aria-label", "Slide timeline left");
        buttonLeft.parentElement.classList.add("btn");
        buttonRight.parentElement.setAttribute("role", "button");
        buttonLeft.parentElement.setAttribute("aria-label", "Slide timeline right");
        buttonRight.parentElement.classList.add("btn");
        buttonLeft.parentElement.setAttribute("aria-disabled", "true");

        buttonLeft.firstChild.setAttribute("alt", "Chevron left icon");
        buttonRight.firstChild.setAttribute("alt", "Chevron right icon");

        buttonRight.parentElement.addEventListener('click', () => {
            scrollRight();
        });
        buttonRight.parentElement.addEventListener('keydown', () => {
            scrollRight();
        });
        buttonLeft.parentElement.addEventListener('click', () => {
            scrollLeft();
        });
        buttonLeft.parentElement.addEventListener('keydown', () => {
            scrollLeft();
        });
    }

    const scrollRight = () => {
        contentScollLeft += 400;
        if (contentScollLeft >= contentScrollWidth) {
            contentScollLeft = contentScrollWidth;
        } else if (!buttonLeft.classList.contains(CLASSES.active)) {
            buttonLeft.classList.add(CLASSES.active);
        }
        slider.scrollLeft = contentScollLeft;
        buttonLeft.parentElement.setAttribute("aria-disabled", "false");
    }

    const scrollLeft = () => {
        contentScollLeft -= 400;
        if (contentScollLeft <= 0) {
            contentScollLeft = 0;
            buttonLeft.classList.remove(CLASSES.active);
            buttonLeft.parentElement.setAttribute("aria-disabled", "true");
        }
        slider.scrollLeft = contentScollLeft;
    }

}

export default navigation;